import { GlobalApiResponse } from "app/core/models/apiResponse.interface";

export class ActionGetStore {
  static readonly type = "[STORE] GET STORE";
  constructor(public payload: GlobalApiResponse) {}
}
